<div
  class="component-container"
>
  <div class="header flex-col">
   <!--  <div class="line-1 text-digital-red flex flex-wrap content-center px-[2.2rem]">
      Stanford University
    </div> -->
    <div
      class="line-2 bg-digital-red text-white font-work-sans flex flex-wrap content-center px-[2.2rem] justify-between">
      <div class="logo">
        <div class="logo-section text-white px-[1rem] flex flex-wrap grow content-center justify-start lg:w-[30rem] md:w-[30rem] sm:w-[25rem] xs:w-[25rem] w-[30rem]">
        <app-image
          class="mobile-logo"
          url="/assets/images/png/logo.png"/>
      </div>
    </div>
      <div *ngIf="currentRouteUrl==='/auth/register/step-1'" class="login-text">
        Already have an account?
        <span
          class="go-to-login"
          (click)="redirectToLogin()"
        >
          Login
        </span>
      </div>
      <div *ngIf="currentRouteUrl==='/auth/password/forgot-password'" class="login-text">
        <span
          class="go-to-login"
          (click)="redirectToLogin()"
        >
          Login
        </span>
      </div>
    </div>
  </div>
  <div class="content flex flex-col md:flex-row">
    <div
      class="left-panel w-full md:h-full xs:hidden"
    >
      <router-outlet name="left-panel"></router-outlet>
    </div>
    <div
      class="right-panel w-full md:min-w-[50%] h-full"
    >
      <router-outlet name="right-panel"></router-outlet>
    </div>
  </div>
</div>
